import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import { Form } from '@sketchpixy/rubix';
import CustomField from '../Fields/CustomField.jsx';
import { CUSTOM_SNIPPET_ENTITY_TYPES, CUSTOM_SNIPPET_ENTITY_TYPES_PARAMETERS, CUSTOM_SNIPPET_EVENT_TYPES, CUSTOM_SNIPPET_EVENT_TYPES_PARAMETERS } from '../../../_config/consts.js';
import TranslatableOption from '../Fields/TranslatableOption.jsx';



const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Required';
  }

  if (!values.entity) {
    errors.entity = 'Required';
  }

  if (!values.event) {
    errors.event = 'Required';
  }

  if (!values.code) {
    errors.code = 'Required';
  }

  return errors;
};

@reduxForm({ form: 'CustomSnippetForm', validate })
@connect(state => ({
  form: state.form.CustomSnippetForm,
  customTables: state.customTables,
  themeName: state.settings.items.theme.data.themeName
}))
class CustomSnippetForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      triggerType: 'time', // 'time' or 'entity'
    };
  }

  onChangeTriggerType = (type) => {
    this.setState({ triggerType: type });
  }

  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    const { triggerType } = this.state;
    const eventTypesOptions = [{ label: 'itemTypeSelect', value: '' }, ..._.map(CUSTOM_SNIPPET_EVENT_TYPES, itemType => ({ label: CUSTOM_SNIPPET_EVENT_TYPES_PARAMETERS[itemType].string, value: itemType }))];
    const entityTypesOptions = [{ label: 'itemTypeSelect', value: '' }, ..._.map(CUSTOM_SNIPPET_ENTITY_TYPES, itemType => ({ label: CUSTOM_SNIPPET_ENTITY_TYPES_PARAMETERS[itemType].string, value: itemType }))];
    return (
      <Form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
          <div style={{ flex: 1, padding: '20px', borderRight: '1px solid #e0e0e0' }}>
            <Entity
              componentClass={Field}
              name="name"
              componentAttribute="placeholder"
              entity="insertSnippetName"
              title={<Entity entity="snippetName" />}
              component={CustomField}
              type="text"
              mandatory
            />

            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <h4><Entity entity="runEvery" /></h4>
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <label style={{ marginRight: '20px' }}>
                  <input
                    type="radio"
                    checked={triggerType === 'time'}
                    onChange={() => this.onChangeTriggerType('time')}
                  />
                  <span style={{ marginLeft: '8px' }}>
                    <Entity entity="onTimeTrigger" />
                  </span>
                </label>
                <label>
                  <input
                    type="radio"
                    checked={triggerType === 'entity'}
                    onChange={() => this.onChangeTriggerType('entity')}
                  />
                  <span style={{ marginLeft: '8px' }}>
                    <Entity entity="onEntityEvents" />
                  </span>
                </label>
              </div>
            </div>

            {triggerType === 'time' && (
              <Entity
                componentClass={Field}
                name="minutes"
                componentAttribute="placeholder"
                entity="insertMinutes"
                title={<Entity entity="minutes" />}
                component={CustomField}
                type="number"
                mandatory
              />
            )}
            <Field
              id="entity"
              name="entity"
              title={<Entity entity="entity" />}
              component={CustomField}
              mandatory
              className="form-control-select"
              componentClass="select"
            >
              {_.map(entityTypesOptions, type =>
                <Entity
                  key={type.value}
                  componentClass={TranslatableOption}
                  value={type.value}
                  componentAttribute="text"
                  entity={type.label}
                />)
              }
            </Field>
            <Field
              id="type"
              name="type"
              title={<Entity entity="event" />}
              component={CustomField}
              mandatory
              className="form-control-select"
              componentClass="select"
            >
              {_.map(eventTypesOptions, type =>
                <Entity
                  key={type.value}
                  componentClass={TranslatableOption}
                  value={type.value}
                  componentAttribute="text"
                  entity={type.label}
                />)
              }
            </Field>
          </div>

          <div style={{ flex: 1, padding: '20px' }}>
            <Entity
              componentClass={Field}
              name="code"
              componentAttribute="placeholder"
              entity="insertCode"
              title={<Entity entity="code" />}
              component={CustomField}
              type="htmlEditor"
              mandatory
            />
          </div>
        </div>
      </Form>
    );
  }
}

export default CustomSnippetForm;
